import { FaGithub, FaLinkedin, FaFacebook, FaInstagram } from "react-icons/fa";
import "../css/Popups.css";

function About({onClose}){
    return(
        <div className="shade">
            <section id="popup">
                <div className="top">
                    <h1>About</h1>
                    <button onClick={onClose} className="closeBtn">X</button>
                </div>

                <div className="mid about-body">
                    <div>
                        <h2>Hey! I am <span className="owner-name">Sahil Ali</span> and I'm a front-end web developer</h2>
                        <p>I'm a fornt-end web developer with experties in HTML, CSS, JavaScript and ReactJS. I have fundamental understanding of mobile first design concepts, cross browser development, API implementation.</p>

                        <div className="social-links">
                            <a href="https://github.com/TheLastShinobi07"><FaGithub /></a>
                            <a href="https://np.linkedin.com/in/sahil-ali-975470313"><FaLinkedin /></a>
                            <a href="https://www.facebook.com/profile.php?id=100038512400740"><FaFacebook /></a>
                            <a href="https://www.instagram.com/sahilali9198/"><FaInstagram /></a>
                        </div>
                    </div>
                </div>

                <div className="bottom">
                    <img src={require("../images/about-bottom.png")} alt="" width="100%" height="50px" />
                </div>
            </section>
        </div>

    )
}
 export default About;